import * as homeActions from 'home/actions'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import * as actions from './actions'
import RankingsPerHour from './RankingsPerHour'
import * as selectors from './selectors'

const RankingsPerHourContainer = props => {
  useEffect(() => {
    if (props.countries.length === 0 && props.isHourlyCountriesIndicator) {
      props.fetchCountries()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.countries, props.fetchCountries])

  return <RankingsPerHour {...props} />
}

RankingsPerHourContainer.propTypes = {
  countries: PropTypes.array,
  fetchCountries: PropTypes.func,
  isHourlyCountriesIndicator: PropTypes.bool,
}

const mapStateToProps = state => ({
  countries: state.countries.list,
  dataPerHour: state.rankings.dataPerHour,
  indicator: state.rankings.indicator,
  isCollapsed: state.rankings.isCollapsed,
  isHourlyCountriesIndicator: selectors.isHourlyCountriesIndicator(state),
  isWeekly: state.rankings.isWeekly,
  selectedCountry: state.rankings.selectedCountry,
  selectedCountryCompared: state.rankings.selectedCountryCompared,
  selectedStore: state.rankings.selectedStore,
  selectedStoreCompared: state.rankings.selectedStoreCompared,
  storesRequestConfig: selectors.storesRequestConfig(state),
  usePercentages: selectors.usePercentages(state),
})

const mapDispatchToProps = {
  fetchCountries: homeActions.fetchCountries,
  setSelectedCountry: actions.setSelectedCountry,
  setSelectedCountryCompared: actions.setSelectedCountryCompared,
  setSelectedStore: actions.setSelectedStore,
  setSelectedStoreCompared: actions.setSelectedStoreCompared,
  toggleCollapsed: actions.toggleCollapsed,
  toggleWeekly: actions.toggleWeekly,
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingsPerHourContainer)
